import { getSchema } from "@tiptap/core"
import Table from "@tiptap/extension-table"
import TableCell from "@tiptap/extension-table-cell"
import TableHeader from "@tiptap/extension-table-header"
import TableRow from "@tiptap/extension-table-row"
import Youtube from "@tiptap/extension-youtube"

import type { Extensions } from "@tiptap/core"
import type { Schema } from "@tiptap/pm/model"
import { getDefaultExtensions, VideoExtension } from "./extensions"
import { IframeExtension } from "./extensions/iframe-extension"

// Canonical extension list used to compute and apply ProseMirror Steps for
// help-center article proposals. Must accept the same node/mark types the
// help-center editor produces so HTML round-trips don't drop content.
//
// Kept minimal-but-complete: schema-affecting extensions only, no React node
// views (this list runs in Node via @tiptap/html as well as in the browser).
export function getProposalEditorExtensions(): Extensions {
	return [
		...getDefaultExtensions({}),
		Table.configure({ resizable: true }),
		TableRow,
		TableHeader,
		TableCell,
		VideoExtension,
		Youtube.configure({ nocookie: true }),
		IframeExtension,
	]
}

let cachedSchema: Schema | null = null
export function getProposalEditorSchema(): Schema {
	if (!cachedSchema) {
		cachedSchema = getSchema(getProposalEditorExtensions())
	}
	return cachedSchema
}
